import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { DhContabilidadConstant } from 'constants/index'

const TipoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='select-modalavanz-tipo' md={12} />
      <Col md={12}>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Select {...field} id='select-modalavanz-tipo' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              {DhContabilidadConstant.__array.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoFormGroup)
